export const DASHBOARD_ASSOCIACAO = () => '/contac/dashboard-associacao';
